export default {
  env: 'dev',
  defaultLanguage: 'en',
  featureToggles: {},
  apiKey: 'QKzU5BQ1sg55qnOo1MJf54IMxWx8djeq4KewYTtU',
}

        